import { Card, Col, Row } from "antd";
import React from "react";
import Avatar from "react-avatar";
import { useHistory } from "react-router-dom";
import CustomIcon from "../CustomIcon";

export default function ProfileCard({ logout, context, plan }) {
	const history = useHistory();

	const orgName = window.localStorage.getItem("org_name");
	return (
		<Card className="profile-card">
			<Row>
				<Col span={4}>
					<Avatar
						name={context.full_name}
						size={60}
						round="40px"
						src={context.profile_picture_url}
					/>
				</Col>
				<Col span={20} style={{ paddingLeft: 16, textAlign: "start" }}>
					<div className="flex flex-alc">
						<div
							style={{
								fontSize: 16,
								flex: 1,
								fontWeight: 700,
								color: "#4d4d4d",
							}}
						>
							{context.full_name}
						</div>
						<span className="subscription-status">{plan?.toUpperCase()}</span>
					</div>
					<div className="font-sm">{window.localStorage.getItem("email")}</div>
					<div className="font-sm" style={{ color: "#4d4d4d" }}>
						{context.role}
					</div>
					{orgName && (
						<div className="font-sm" style={{ color: "#4d4d4d" }}>
							{orgName}
						</div>
					)}
				</Col>
			</Row>
			<hr style={{ margin: 0, marginTop: 16, marginBottom: 16 }} />
			<div
				className="profile-card-color"
				style={{ textAlign: "start", alignItems: "center" }}
			>
				<div
					onClick={() =>
						history.push({
							pathname: "/settings/account-and-billing",
							state: "wallet",
						})
					}
					className="flex-alc cursor-pointer mt-1"
					style={{ fontSize: 16 }}
				>
					<CustomIcon icon="write" size={12} isSvg={true} /> Edit Profile
				</div>
				<div
					onClick={() =>
						window.open("https://satisfilabs.com/terms-and-conditions/")
					}
					className="flex-alc cursor-pointer mt-1"
					style={{ fontSize: 16 }}
				>
					<CustomIcon icon="terms" size={12} isSvg={true} />
					Terms & Condition
				</div>
				<div
					onClick={logout}
					className="flex-alc cursor-pointer mt-1"
					style={{ fontSize: 16 }}
				>
					<CustomIcon icon="logout" size={12} isSvg={true} />
					Logout
				</div>
			</div>
		</Card>
	);
}
